import { csmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-csm-customer-access/src/csmGlobalCustomerAccessSettingsResource.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { productsJcsCustomerAccessEntryPoint as main } from '@jira/spa-apps__admin-pages-products-jcs-customer-access/src/productsJcsCustomerAccessEntryPoint.entrypoint.tsx';
import {
	jsmGlobalCustomerAccessAffectedProjectsResource,
	csmFilteredAffectedProjectsResource,
} from '@jira/router-resources__admin-pages-jsm-customer-access/src/jsmGlobalCustomerAccessAffectedProjectsResource.tsx';
import { jsmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-jsm-customer-access/src/jsmGlobalCustomerAccessSettingsResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJcsCustomerAccessRoute } from '@jira/router-routes__admin-pages-jcs-customer-access-routes/src/productsJcsCustomerAccessRoute.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import type { Route } from '@atlassian/react-resource-router';

const productsJcsCustomerAccessEntryPointPage = createPageEntryPoint({
	main,
});

export const productsJcsCustomerAccessRouteEntry: Route = createEntry(
	productsJcsCustomerAccessRoute,
	() => ({
		group: 'global-settings',

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		entryPoint: () => productsJcsCustomerAccessEntryPointPage,

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			resourceWithCondition(
				() => !fg('csm_customer_access_jsm_separation'),
				jsmGlobalCustomerAccessAffectedProjectsResource,
			),
			resourceWithCondition(
				() => fg('csm_customer_access_jsm_separation'),
				csmFilteredAffectedProjectsResource,
			),
			resourceWithCondition(
				() => !fg('csm_customer_access_jsm_separation'),
				jsmGlobalCustomerAccessSettingsResource,
			),
			resourceWithCondition(
				() => fg('csm_customer_access_jsm_separation'),
				csmGlobalCustomerAccessSettingsResource,
			),
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
